import React, { useEffect, useState } from 'react'

import { v4 } from 'uuid'
import '@src/css/components/Code.css'
import { logger } from '@src/utils/logger'

const apiUrl = '/api'

export let sendData = async (url: string, data: any) => {
    const response = await fetch(apiUrl + url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer anonymous-${v4()}`,
        },
        body: JSON.stringify(data),
    })

    const json = response.json()
    logger.debug('Response:', json)
    return json
}

const Code = () => {
    const [code, setCode] = useState('')
    const [name, setName] = useState('')
    const [loading, setLoading] = useState(false)
    const [codeError, setCodeError] = useState(false)
    const [nameError, setNameError] = useState(false)

    document.title = 'CODE'

    // Подгружаем из localStorage
    useEffect(() => {
        const savedName = localStorage.getItem('name')
        if (savedName) setName(savedName)
    }, [])

    // Сохраняем в localStorage
    useEffect(() => {
        localStorage.setItem('name', name)
    }, [name])

    const handleLogin = () => {
        if (code.length === 4 && name) {
            setLoading(true)
            sendData('/code', { code, name })
                .then((r) => {
                    logger.debug('Login response:', r)
                    setLoading(false)
                    setCodeError(!r.correct)
                })
                .catch((err) => {
                    logger.error('Login error:', err)
                    setLoading(false)
                })
        } else {
            setCodeError(code.length !== 4)
            setNameError(!name)
        }
    }

    return (
        <div className={'code'}>
            <input
                type='tel'
                inputMode='numeric'
                maxLength={4}
                placeholder='CODE'
                value={code}
                onChange={(e) => {
                    setCode(e.target.value.replace(/\D/g, ''))
                    setCodeError(false)
                }}
                className={codeError ? 'code_input code_input_error' : 'code_input'}
            />
            <input
                type='text'
                placeholder='Name'
                value={name}
                onChange={(e) => {
                    setName(e.target.value)
                    setNameError(false)
                }}
                className={nameError ? 'code_input code_input_error' : 'code_input'}
            />
            <div
                className='login_button'
                onClick={handleLogin}
                style={{ opacity: loading ? 0.6 : 1, pointerEvents: loading ? 'none' : 'auto' }}
            >
                {loading && <div className='spinner'></div>}
                Login
            </div>
        </div>
    )
}

export default Code
